// Library Methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Alert from "src/components/shared/alerts/Alert/Alert";
import DeviationAndCorrespondenceGraph from "./DeviationAndCorrespondenceGraph/DeviationAndCorrespondenceGraph";
import FusionAndVergenceGraph from "./FusionAndVergenceGraph/FusionAndVergenceGraph";
import StereopsisGraph from "./StereopsisGraph/StereopsisGraph";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Constants
import {
  algorithmTypes,
  examCardEnums,
  ExamCardSectionNameType,
} from "src/constants/enums";

// Utils
import { isTerminatedExamReport } from "src/utils/exams/examReportsHelper";

const SynoptophoreGraph = () => {
  const { t } = useTranslation();

  const { exam } = useContext(ReportContext);
  const { examReport } = useContext(ReportSectionContext);

  const examAlgorithm = useMemo(
    () => examReport?.exam?.algorithm,
    [examReport?.exam?.algorithm]
  );

  const isTerminated = useMemo(() => {
    let sectionName: ExamCardSectionNameType =
      examCardEnums.DEVIATION_AND_CORRESPONDENCE.sectionName;

    if (examAlgorithm === algorithmTypes.FUSION_AND_VERGENCE) {
      sectionName = examCardEnums.FUSION_AND_VERGENCE.sectionName;
    } else if (examAlgorithm === algorithmTypes.STEREOPSIS) {
      sectionName = examCardEnums.STEREOPSIS.sectionName;
    }

    return isTerminatedExamReport({
      exam,
      examReport,
      sectionName,
    });
  }, [exam, examReport, examAlgorithm]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "20px",
          }}
        >
          {isTerminated && (
            <Alert
              variant="error"
              alertContent={t("Terminated Exam")}
              props={{ width: "100%" }}
            />
          )}

          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            {examAlgorithm === algorithmTypes.DEVIATION_AND_CORRESPONDENCE && (
              <DeviationAndCorrespondenceGraph />
            )}
            {examAlgorithm === algorithmTypes.FUSION_AND_VERGENCE && (
              <FusionAndVergenceGraph />
            )}
            {examAlgorithm === algorithmTypes.STEREOPSIS && <StereopsisGraph />}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SynoptophoreGraph;
